module.exports = __webpack_public_path__ + "static/media/developers2.cf83e454.jpg";